var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titlebar-left"},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.msg.title))]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.msg.subTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }